<template>
  <div>
    <template v-if="marker">
      <v-toolbar
        elevation="1"
        dark
        dense
        color="highlight"
        flat
        v-bind:class="$store.state.isOffline ?'sticky' :'sticky-toolbar-breadcrumb'"
      >
        <v-toolbar-title>{{$t("marker")}} {{marker !== null ? marker.number : ''}} {{marker.label ? ` - ${marker.label}`:''}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-menu transition="scale-transition" origin="right top"  offset-y bottom left  style="z-index: 10" class="white">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" icon v-on="on">
              <v-icon>fa-info-circle</v-icon>
            </v-btn>
          </template>
          <v-sheet flatwidth="600px">
            <v-list dense>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">fa-toolbox</v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{$t('info_marker_details')}}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-sheet>
        </v-menu>-->
        <template>
          <v-toolbar-items>
            <template>
              <archivedReports :marker="marker"></archivedReports>
            </template>
          </v-toolbar-items>
          <v-toolbar-items>
            <template v-if="!$store.state.isOffline">
              <can I="update" a="blueprints">
                <reports v-on:updateMarker="updateMarker" :marker="marker"></reports>
              </can>
            </template>
          </v-toolbar-items>
          <v-toolbar-items>
            <can I="update" a="markers">
              <template>
                <addQRCode v-on:updateMarker="updateMarker" :marker="marker"></addQRCode>
              </template>
            </can>
          </v-toolbar-items>
          <!-- <v-toolbar-items> -->
          <can I="update" a="markers">
            <template>
              <v-btn class="ml-2" depressed small color="secondary" @click="updateMarker">
                <template v-if="!$store.state.hasChanges">{{$t('save')}}</template>
                <v-badge v-else color="orange">
                  <template v-slot:badge>
                    <v-icon dark small>priority_high</v-icon>
                  </template>
                  <span>{{$t('save')}}</span>
                </v-badge>
              </v-btn>
            </template>
          </can>

          <v-menu
            transition="scale-transition"
            origin="right top"
            v-if="!$store.state.isOffline"
            offset-y
            style="z-index: 10"
            class="white"
            :close-on-content-click="false"
            bottom
            left
          >
            <template v-slot:activator="{ on }">
              <v-btn color="white" icon v-on="on">
                <v-icon>more_vert</v-icon>
              </v-btn>
            </template>
            <v-sheet flatwidth="600px">
              <v-list dense>
                <can I="delete" a="markers">
                  <areyousure list_item v-on:delete="deleteMarker" :id="marker.id" object="marker"></areyousure>
                </can>
              </v-list>
            </v-sheet>
          </v-menu>
          <!-- </v-toolbar-items> -->
        </template>
      </v-toolbar>
        <v-sheet tile v-if="$store.state.readyForOffline && $store.state.allAttributes && $store.state.productSolutions" class="text-center white--text" flat color="green">
      <template v-if="!$store.state.isOffline">
        <v-icon color="white">done</v-icon> {{$t('readyForOffline')}}
      </template>
      <template v-else>
        <v-icon color="white">cached</v-icon> {{$t('goOnline')}}
      </template>
      </v-sheet>
      <v-expand-transition>
        <isLocked
          v-on:close="showLockedMessage = false"
          v-if="showLockedMessage"
          :blueprint="blueprint"
        ></isLocked>
      </v-expand-transition>
      <!-- <v-card flat > -->
      <v-layout class="mb-5" v-if="marker && blueprint && $store.state.productSolutions" wrap>
        <v-flex lg7 xs12>
          <v-container>
            <v-form ref="form" class="compact-form" v-model="valid">
              <v-card>
                <v-container grid-list-md text-xs-center>
                  <v-text-field
                    outlined
                    dense
                    :rules="[v => v.length <= 20 || '']"
                    :label="$t('markerLabel')"
                    v-model="marker.label"
                    :maxlength="20"
                    counter="20"
                  ></v-text-field>
                  <v-menu
                    transition="scale-transition"
                    origin="right top"
                    ref="menu1"
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        outlined
                        dense
                        readonly
                        v-model="marker.date"
                        v-bind:label="$t('applicationDate')"
                        persistent-hint
                        prepend-icon="event"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="marker.date" no-title></v-date-picker>
                  </v-menu>
                  <!-- <can I="update" a="installers">
                <v-layout>
                  <v-select
                    outlined
                    v-model="marker.installerId"
                    :items="installers"
                    item-value="Id"
                    v-bind:label="$t('form.installer')"
                    :clearable="true"
                    :dense="true"
                    return-masked-value
                  >
                    <template slot="selection" slot-scope="data">
                      <template>{{ data.item.Name }} {{ data.item.Firstname }}</template>
                    </template>
                    <template slot="item" slot-scope="data">
                      <template>{{ data.item.Name }} {{ data.item.Firstname }}</template>
                    </template>
                  </v-select>
                </v-layout>
                  </can>-->
                  <!-- <can I="read" a="installers"> -->
                  <template v-if="marker.installer != null">
                    <small class="v-label theme--light">
                      <p class="mb-0 text-sm-left">{{$t("installer")}}</p>
                    </small>
                    <p class="text-sm-left">{{marker.installer.firstname}} {{marker.installer.name}}</p>
                  </template>
                  <v-select
                    :value="marker.status"
                    outlined
                    dense
                    :menu-props="{ bottom: true, offsetY: true }"
                    :label="$t('status')"
                    item-value="id"
                    @change="changeStatusMarker"
                    :items="statusItems"
                  >
                    <template v-slot:item="{item, index}">
                      <!-- <span v-html="item.name"/> -->
                      <v-icon :color="item.color">{{item.icon}}</v-icon>
                      {{item.name}}
                    </template>
                    <template v-slot:selection="{item, index}">
                      <!-- <span v-html="item.name"/> -->
                      <v-icon :color="item.color">{{item.icon}}</v-icon>
                      {{item.name}}
                    </template>
                  </v-select>
                  <!-- </can> -->
                </v-container>
              </v-card>
              <div class="mb-3 mt-3">
                <transition name="flip" mode="out-in">
                  <solutionsList
                    key="'s'"
                    v-bind:marker="marker"
                    v-on:addMarkerXSolution="addMarkerXSolution"
                    v-on:selected="selected"
                    v-on:open="openSolution"
                    :blueprint="blueprint"
                  ></solutionsList>
                </transition>
              </div>
              <v-card>
                <v-container>
                  <v-textarea outlined v-model="marker.comments" v-bind:label="$t('comments')"></v-textarea>
                </v-container>
              </v-card>
            </v-form>
          </v-container>
        </v-flex>
        <v-flex v-if="!$store.state.isMobile" lg5 xs12>
          <v-container>
            <zoomMarkup v-bind:detailPage="true" v-bind:blueprint="blueprint"></zoomMarkup>
          </v-container>
        </v-flex>
      </v-layout>
      <v-container fill-height v-else>
        <loading></loading>
      </v-container>
      <!-- </v-card> -->
      <div
        v-if="blueprint && blueprint.blueprintFile.content  && $store.state.isMobile"
        outlined
        color="primary"
        class="floating-button"
      >
        <zoomMarkup ref="markup" v-bind:detailPage="true" v-bind:blueprint="blueprint"></zoomMarkup>
      </div>
      <savebeforeleave v-on:response="response" :dialog="saveDialog"></savebeforeleave>
    </template>
    <v-container fill-height v-else>
      <loading></loading>
    </v-container>
  </div>
</template>



<script>
import jwtdecode from "jwt-decode";
import uuid from "uuid";
import addQRCode from "@/components/pages/Markers/AddQRCode";
import zoomPicture from "@/components/pages/Markers/ZoomPicture";
import solutionsList from "@/components/pages/Markers/MarkerXSolutions/List";
import reports from "@/components/pages/Markers/Reports";
import archivedReports from "@/components/pages/Markers/archivedReports";
import zoomMarkup from "@/components/pages/Markers/ZoomMarkup";
import { serviceihub } from "@/services/service.ihub.js";
import { constants } from "crypto";
import { Promise, all } from "q";
import isLocked from "@/components/pages/Blueprints/IsLocked";

const _serviceIhub = new serviceihub();

export default {
  name: "markerDetails",
  components: {
    zoomPicture,
    addQRCode,
    solutionsList,
    zoomMarkup,
    reports,
    isLocked,
    archivedReports,
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.hasChanges) {
      if (to.name !== "MarkerXSolutionDetails") {
        this.saveDialog = true;
        //this.$store.state.hasChanges = false;
        this.to = to;
        next(false);
      } else {
        next();
      }
    } else {
      if (
        to.name != "EditBlueprintsDetails" &&
        to.name != "MarkerXSolutionDetails"
      ) {
        if (this.$can("update", "markers")) {
          this.$http
            .lockBlueprint(this.blueprint.id)
            .then((res) => {
              if (to.name === "Login") {
                localStorage.removeItem("auth");
                localStorage.removeItem("user");
              }
              next();
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          next();
        }
      } else {
        next();
      }
    }
  },
  props: {
    markerid: String,
    //marker: Object
  },
  data() {
    return {
      admin: false,
      dialog: false,
      // installers: null,
      attachment: null,
      loaded: false,
      marker: null,
      menu: false,
      valid: false,
      //productSolutions: "",
      blueprint: null,
      selectedFile: null,
      nameRules: [
        (v) => !!v || "Name is required",
        //v => v.length <= 25 || "Name must be less than 10 characters"
      ],
      isLoading: false,
      search: null,
      saveDialog: false,
      to: null,
      loadingText: "",
      showLockedMessage: false,
    };
  },
  computed: {
    isOffline() {
      return this.$store.state.isOffline;
    },
    isSyncing() {
      return this.$store.state.offlineSyncing;
    },
    statusItems() {
      return [
        {
          id: "0",
          name: this.$t("broken"),
          icon: "priority_high",
          color: "red",
          disabled: false,
        },
        {
          id: "1",
          name: this.$t("inProcess"),
          icon: "priority_high",
          color: "orange",
          disabled: true,
        },
        {
          id: "2",
          name: this.$t("approved"),
          icon: "check_circle",
          color: "success",
          disabled: false,
        },
      ];
    },
    label() {
      if (this.marker) {
        return this.marker.label;
      }
    },
  },
  methods: {
    openSolution(mxs) {
      this.$router.push({
        name: "MarkerXSolutionDetails",
        params: {
          id: this.marker.id,
          markerXSolutionId: mxs.id,
          markerXSolution: mxs,
          marker: this.marker,
          blueprint: this.blueprint,
          readonly: false,
        },
      });
    },
    deleteMarker(id) {
      this.$store.state.markers = this.$store.state.markers.filter(
        (p) => p.id != id
      );
      this.$store.state.markersReadonly = [];
      this.$router.push({
        name: "EditBlueprintsDetails",
        params: {
          id: this.blueprint.id,
          blueprint: this.blueprint,
        },
      });
    },
    changeStatusMarker(e) {
      this.$store.state.hasChanges = true
      this.marker.manualStatus = e;
      this.marker.status = e;
    },
    checkIfBlueprintIsLocked() {
      if (this.blueprint.isLocked) {
        if (
          this.blueprint.lockedByUserId !=
          parseInt(jwtdecode(localStorage.getItem("auth")).contactId)
        ) {
          this.$noty.info(
            `${this.blueprint.lockedByUserName}  ${this.$t(
              "blueprintLockedSince"
            )} ${this.blueprint.lockedTs}`
          );

          this.$router.push({
            name: "MarkerDetails",
            params: { id: this.$route.params.id },
          });
        }
      } else {
        this.$router.push({
          name: "MarkerDetails",
          params: { id: this.$route.params.id },
        });
      }
    },
    lockBlueprint() {
      if (this.$can("update", "markers")) {
        this.$http
          .lockBlueprint(this.blueprint.id)
          .then((res) => {
            if (
              res.data.lockedByUserId ==
              parseInt(jwtdecode(localStorage.getItem("auth")).contactId)
            ) {
              this.blueprint.isLocked = res.data.isLocked;
              this.blueprint.lockedByUserId = res.data.lockedByUserId;
              this.blueprint.lockedByUserName = res.data.lockedByUserName;
            } else {
              this.showLockedMessage = true;
            }
          })
          .catch((err) => {
            console.log(err);
            this.$noty.error(this.$t("error"));
          });
      }
    },
    response(answer) {
      if (answer) {
        this.updateMarker();
        this.$store.state.markerDetailSaved = true;
      } else {
        this.$store.state.markerDetailSaved = false;
        this.$store.state.hasChanges = false
      }
      this.saveDialog = false;
      // this.$router.push({
      //   name: this.to.name,
      //   params: this.to.params,
      // });
    },
    makeBackButton() {
      this.$store.state.previous = {
        name: "EditBlueprintsDetails",
        params: {
          id: this.blueprint.id,
          blueprint: this.blueprint,
        },
        id: this.blueprint.id,
        breadcrumb: this.$t("blueprint"),
      };
    },
    makeBreadcrumb() {
      this.$store.state.breadcrumb = [
        {
          name: this.$t("projects"),
          to: { name: "Projects" },
        },
        {
          name: this.blueprint.project,
          to: {
            name: "ProjectDetails",
            params: { id: this.blueprint.projectId },
          },
        },
        {
          name: this.blueprint.buildingComponent,
          to: {
            name: "BuildingComponentDetails",
            params: { id: this.blueprint.buildingComponentId },
          },
        },
        {
          name: this.blueprint.name,
          to: {
            name: "EditBlueprintsDetails",
            params: { id: this.blueprint.id },
          },
        },
        {
          name: `${this.$t("marker")} ${this.marker.number} ${
            this.marker.label ? " - " + this.marker.label : ""
          }`,
        },
      ];
    },
    selected(solutionId, selected) {
      this.marker.markerXSolutions.forEach((mxs) => {
        if (mxs.solutionId == solutionId) {
          mxs.selectedProducts = selected.reduce((res, x) => {
            if (x.selected) {
              var someNewValue = {
                id: uuid.v4(),
                markerXSolutionsId: mxs.id,
                productId: x.id,
              };
              res.push(someNewValue);
            }
            return res;
          }, []);
        }
      });
    },
    updateMarker(event, fromMxsDetails = false) {
      this.$store.state.markersReadonly = [];
      let markerFromStore = this.$store.getters.markers.find(
        (x) => x.id == this.$route.params.id
      );
      //marker changes like adding solutions,images,etc we pass the marker object down to the components.
      //marker position changes are set in the list of markers in the store.

      this.marker.coordX = markerFromStore.coordX;
      this.marker.coordX2 = markerFromStore.coordX2;
      this.marker.coordY = markerFromStore.coordY;
      this.marker.coordY2 = markerFromStore.coordY2;

      if (this.valid) {
        this.$store.state.hasChanges = false;
        

        if (this.$store.state.isOffline) {
          let offForm = {
            marker: this.marker,
          };

          this.$store.commit("addOrUpdateOffForm", offForm);
          this.$noty.warning(this.$t("cached"));
          this.$store.commit("AddAndSetUIelements", this.marker);
        } else {
          if (this.marker.markerXSolutions.some((e) => e.solutionId !== null)) {
            this.$http
              .updateMarker(this.marker)
              .then((res) => {
                this.marker = res.data;
                this.$store.commit("AddAndSetUIelements", this.marker);
                this.$noty.success('<i class="fas fa-check"></i>');

                //change the new markerxsolutions to existing
                this.marker.markerXSolutions.forEach((mxs) => {
                  if (mxs.new) delete mxs.new;
                  mxs.attachments.forEach((attachment) => {
                    if (attachment.new) delete attachment.new;
                  });
                });
              })
              .catch((err) => {
                console.log(err);
                this.$noty.error(this.$t("error"));
              });
          } else {
            this.$noty.warning(this.$t("selectsolution"));
          }
        }
      } else {
        this.$noty.warning(this.$t("fillinrequiredfields"));
      }
    },
    addSolution(newSolution) {
      this.$http
        .addSolution(newSolution)
        .then((res) => {
          this.$store.state.productSolutions.push(res.data);
          this.$noty.success('<i class="fas fa-check"></i>');
        })
        .catch((err) => {
          this.$noty.error(this.$t("error"));
          console.log(err);
        });
    },
    canDelete(date) {
      if (date.substring(0, 10) == new Date().toLocaleDateString("fr-CA"))
        //yyyy-MM-dd
        return true;
      else return false;
    },
    getProductSolutions() {
      if (this.$store.state.productSolutions == null) {
        this.$http
          .getProductSolutions(true)
          .then((res) => {
            this.$store.state.productSolutions = res.data;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    addMarkerXSolution(markerXSolution) {
      this.marker.markerXSolutions.push(markerXSolution);
      setTimeout(() => {
        this.$router.push({
          name: "MarkerXSolutionDetails",
          params: {
            id: this.marker.id,
            markerXSolutionId: markerXSolution.id,
            markerXSolution: markerXSolution,
            marker: this.marker,
            blueprint: this.blueprint,
            readonly: false,
          },
        });
      }, 500);
    },
    updatePosition(marker) {
      this.marker.coordX2 = marker.coordX2;
      this.marker.coordY2 = marker.coordY2;
      this.marker.coordX = marker.coordX;
      this.marker.coordY = marker.coordY;
    },
    async getAllAttributesAndSaveInStore() {
      if (this.$store.state.allAttributes == null) {
        try {
          let res = await this.$http.getAttributes(false, true);
          this.$store.state.allAttributes = res.data;
        } catch (err) {
          console.log(err);
        }
      }
    },
  },
  watch: {
    marker(n, o) {
      console.log("Watching marker now...");

      if (n != null || n != undefined) {
        if (n.installerId == null) {
          this.marker.installerId = parseInt(
            jwtdecode(localStorage.getItem("auth")).contactId
          );
        }
      }
    },
    isSyncing(n, o) {
      if (!n && o === true) {
        this.marker = this.$store.state.markers.find(
          (x) => x.id == this.$route.params.id
        );
      }
    },
    blueprint(n, o) {
      if (n) {
        if (n.isArchived) {
          this.$router.push({
            name: "ArchivedBlueprintsDetails",
            params: { id: n.id },
          });
        }
      }
    },
    label(n, o) {
      if (o && n !== o) {
        this.$store.state.hasChanges = true;
      }
    },
  },
  created() {
    if (this.$store.state.isOffline) {
      this.marker = this.$store.state.markers.find(
        (x) => x.id == this.$route.params.id
      );
      this.blueprint = this.$route.params.blueprint;
      this.makeBackButton();
      if (this.$route.params.saveMarker) {
        this.$nextTick(() => {
          this.updateMarker();
          this.$route.params.saveMarker;
        });
      } else if (this.$route.params.deleteMarkerXSolution) {
        this.marker = this.$route.params.deleteMarkerXSolution;
        this.$store.commit("AddAndSetUIelements", this.marker);
      }

      this.checkIfBlueprintIsLocked();
    } else {
      
      this.getAllAttributesAndSaveInStore();
      this.marker = this.$route.params.marker;
      this.blueprint = this.$route.params.blueprint;
      if (this.marker === undefined) {
        
        this.$http.getMarker(this.$route.params.id).then((res) => {
          this.marker = res.data;
          this.$store.state.markers = [];
          this.$store.commit("AddAndSetUIelements", res.data);
          this.$http
            .getBlueprint(this.marker.blueprintId)
            .then((res) => {
              this.blueprint = res.data;
              this.makeBackButton();
              this.makeBreadcrumb();
              this.checkIfBlueprintIsLocked();
            })
            .catch((err) => console.log(err));
        });
      } else {
        
        this.makeBackButton();
        this.makeBreadcrumb();
        if (this.$route.params.saveMarker) {
          this.$nextTick(() => {
            this.updateMarker(null, true);
          });
        }

        this.checkIfBlueprintIsLocked();
      }

      this.getProductSolutions();
    }
  },
};
</script>

<style >
</style>


// WEBPACK FOOTER //
// src/views/markers/edit/Details.vue